"use client"

import { atom } from 'jotai';
import { getUniqueTabId } from "@/utils/unique-tab-id.ts";

export const uniqueTabIdAtom = atom(getUniqueTabId() || '');
